export const EnvironmentConfig =
{
    "_baseURL": "https://ussuint0atwap01.azurewebsites.net",
    get "MEMObaseURL"() {
        return this["_baseURL"];
    },
    set "baseURL"(value) {
        this["_baseURL"] = value;
    },
    "_APIURL": "lZ1DdU6XiaOD7hHrl71phHF/YXXuGQbW3WsaTXxs9ik=",
    get "APIURL"() {
        return this["_APIURL"];
    },
    set "APIURL"(value) {
        this["_APIURL"] = value;
    },
    "_graphAPIBase": "https://graph.windows.net/bttp-uat.ey.com",
    get "graphAPIBase"() {
        return this["_graphAPIBase"];
    },
    set "graphAPIBase"(value) {
        this["_graphAPIBase"] = value;
    },
    "_graphAPIResource": "00000002-0000-0000-c000-000000000000",
    get "graphAPIResource"() {
        return this["_graphAPIResource"];
    },
    set "graphAPIResource"(value) {
        this["_graphAPIResource"] = value;
    },
    "_RedirectURL": "https://bttp-uat.ey.com",
    get "RedirectURL"() {
        return this["_RedirectURL"];
    },
    set "RedirectURL"(value) {
        this["_RedirectURL"] = value;
    },
    "_TenantValue": "5b973f99-77df-4beb-b27d-aa0c70b8482c",
    get "TenantValue"() {
        return this["_TenantValue"];
    },
    set "TenantValue"(value) {
        this["_TenantValue"] = value;
    },
    "_ClientIdValue": "682077ac-4d4b-4b7c-9aa2-83fa7ba7c19e",
    get "ClientIdValue"() {
        return this["_ClientIdValue"];
    },
    set "ClientIdValue"(value) {
        this["_ClientIdValue"] = value;
    },
    "_Rows": "1000576",
    get "MaxRows"() {
        return this["_Rows"];
    },
    set "MaxRows"(value) {
        this["_Rows"] = value;
    },
    "_Columns": "16384",
    get "MaxColumns"() {
        return this["_Columns"];
    },
    set "MaxColumns"(value) {
        this["_Columns"] = value;
    },
    "_FileSize": "100000",
    get "MaxSize"() {
        return this["_FileSize"];
    },
    set "MaxSize"(value) {
        this["_FileSize"] = value;
    },
};
export const TimeOutDuration = 1000 * 60 * 1;
export const WarningTimeoutDuration = 1000 * 60 * 19;

